/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_prev': {
    width: 39,
    height: 39,
    viewBox: '0 0 39 39',
    data: '<circle pid="0" cx="19.5" cy="19.5" r="19.5" _fill="#5F01D3"/><path pid="1" d="M24 11l-9 9 9 9" _stroke="#fff" stroke-width="3"/>'
  }
})
